import { useAuth } from '@deltasuite/auth';
import { type ReactNode } from 'react';
import { LoginScreen } from './LoginScreen';

// Renders <LoginScreen/> when signed out, the app when signed in, and a
// neutral splash while the provider boots / detects the URL hash. The
// signed-in state passes through to children — useAuth() inside the app
// surfaces the user / token.
export function AuthGate({ children }: { children: ReactNode }) {
  const { state } = useAuth();

  if (state.status === 'loading') {
    return (
      <main className="flex min-h-full items-center justify-center">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-graphite-500">
          Signing in…
        </p>
      </main>
    );
  }

  if (state.status === 'signed_out') {
    return <LoginScreen />;
  }

  return <>{children}</>;
}
